import { isArray } from 'lodash';
import React, { memo } from 'react';

import { removeSeconds } from '../../../service/DateTimeUtils';
import { Fields } from './Fields/Fields';
import { getUnderlineType } from './tools';

export const CustomPaletteField = memo(
    ({ id, title, length, limit, type, multiline, required = false, onChange, defaultValue, shortcuts, validator = {} }) => {
        const actualLimit = validator.limit ? validator.limit : limit;
        const [underlineType, setUnderlineType] = React.useState(
            getUnderlineType(
                defaultValue,
                isArray(actualLimit) ? actualLimit[1] : actualLimit,
                isArray(validator.length) ? validator.length[1] : validator.length,
                required
            )
        );
        const minRows = (multiline || {}).minRows || 1;
        const maxRows = (multiline || {}).maxRows || (multiline || {}).rowsMax || 1;

        const handleChangeTime = React.useCallback(
            (event, value) => {
                onChange(id, value ? removeSeconds(value) : null);
            },
            [id, onChange]
        );

        const handleFieldBlur = React.useCallback(
            (value) => {
                setUnderlineType(
                    getUnderlineType(
                        value,
                        isArray(actualLimit) ? actualLimit[1] : actualLimit,
                        isArray(validator.length) ? validator.length[1] : validator.length,
                        required
                    )
                );
            },
            [actualLimit, validator, required]
        );

        const fieldsProps = {
            defaultValue,
            handleChangeTime,
            id,
            length,
            maxRows,
            minRows,
            multiline,
            onBlur: handleFieldBlur,
            onChange,
            required,
            title,
            underlineType,
            validator,
            shortcuts,
        };

        return <Fields type={type} fieldsProps={fieldsProps} />;
    }
);
